import React from "react";
import HighChart from "./HighChart";
import { createDynamicAgeRangeObject } from "../../utility/utility";
import Skeleton from "react-loading-skeleton";
import { AGE_RANGE } from "../../constants/constants";

interface AgeChartProps {
  ageStats: {
    number_of_consents_per_age: {
      [age: number]: string;
    };
  };
}

const AgeChart: React.FC<AgeChartProps> = (props) => {
  const updatedAgeData = createDynamicAgeRangeObject(
    props?.ageStats?.number_of_consents_per_age,
    AGE_RANGE
  );
  const categories = Object.keys(updatedAgeData);
  const seriesData = Object.values(updatedAgeData).map(Number);

  const ageChartOptions = {
    chart: {
      type: "column",
      height: "220px",
    },
    title: {
      text: "",
    },
    xAxis: {
      categories, // Use categories for age ranges
      lineColor: "rgba(164, 165, 181, 0.2)",
    },
    yAxis: {
      title: {
        text: "",
      },
      gridLineDashStyle: "Dash", // Set Y-axis grid lines to dashed
      gridLineColor: "rgba(164, 165, 181, 0.2)", // Optional: set grid line color
      gridLineWidth: 1,
    },
    credits: {
      enabled: false, // Disable credits
    },
    legend: {
      enabled: false,
    },
    series: [
      {
        name: "No of consents",
        data: seriesData, // Data points corresponding to categories
        color: "#9930dc",
      },
    ],
  };

  return props?.ageStats ? (
    <HighChart options={ageChartOptions} />
  ) : (
    <Skeleton count={8} />
  );
};

export default AgeChart;
